import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Container, Row, Col, Card, Button, Alert } from 'react-bootstrap';
import logo from "../../images/logo-nero-sportid.svg";
import MyApiClient from '../../api-client/MyApiClient';

const ManageInvite = () => {
    const { phoneNumber, userId, clubId, clubName } = useParams();
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [rejected, setRejected] = useState(false);

    useEffect(() => {
        // Verifica che tutti i parametri necessari siano presenti
        if (!phoneNumber || !userId || !clubId || !clubName) {
            console.error('Parametri mancanti nell\'URL');
        }
    }, [phoneNumber, userId, clubId, clubName]);

    const handleAcceptInvite = async (e) => {
        e.preventDefault();
        
        const newErrors = {};
        setErrors(newErrors);
        
        if (Object.keys(newErrors).length === 0) {
            setLoading(true);
            
            try {
                console.log('Accettazione invito:', {
                    phoneNumber,
                    userId,
                    clubId,
                    accepted: true
                });
                
                const apiClient = new MyApiClient();
                const response = await apiClient.manageInvite(userId, clubId, phoneNumber, '', true);
                console.log(response);
                
                if(response.error && response.error.detail){
                    setErrors({ general: response.error.detail });
                } else {
                    setSuccess(true);
                }
                
            } catch (error) {
                console.error('Errore durante l\'accettazione:', error);
                setErrors({ general: 'Si è verificato un errore durante l\'accettazione. Riprova più tardi.' });
            } finally {
                setLoading(false);
            }
        }
    };

    const handleRejectInvite = async (e) => {
        e.preventDefault();
        setLoading(true);
        
        try {
            console.log('Rifiuto invito:', {
                phoneNumber,
                userId,
                clubId,
                accepted: false
            });
            
            const apiClient = new MyApiClient();
            const response = await apiClient.manageInvite(userId, clubId, phoneNumber, '', false);
            console.log(response);
            
            if(response.error && response.error.detail){
                setErrors({ general: response.error.detail });
            } else {
                setRejected(true);
            }
            
        } catch (error) {
            console.error('Errore durante il rifiuto:', error);
            setErrors({ general: 'Si è verificato un errore durante il rifiuto. Riprova più tardi.' });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="vh-100 d-flex align-items-center" style={{ backgroundColor: '#f8f9fa' }}>
            <Container>
                <Row className="justify-content-center">
                    <Col md={6} lg={5}>
                        <Card className="shadow-sm border-0">
                            <Card.Body className="p-5">
                                <div className="text-center mb-4">
                                    <img src={logo} alt="SportID" style={{ height: '60px' }} />
                                </div>
                                
                                <h4 className="text-center mb-4 text-dark">
                                    Gestisci l'invito della struttura
                                </h4>
                                
                                <Alert variant="warning" className="mb-4" style={{backgroundColor: '#fff3cd', borderColor: '#ffeaa7', color: '#856404'}}>
                                    <strong>Accetta o rifiuta l'invito della struttura {clubName} per collegarti su SportId</strong>
                                </Alert>
                                
                                {phoneNumber && (
                                    <div className="mb-3">
                                        <small className="text-muted">
                                            Numero di telefono: <strong>{phoneNumber}</strong>
                                        </small>
                                    </div>
                                )}

                                {success ? (
                                    <Alert variant="success">
                                        <h5>Invito accettato con successo!</h5>
                                        <p>Controlla la tua email per le istruzioni per continuare la registrazione su SportID.</p>
                                    </Alert>
                                ) : rejected ? (
                                    <Alert variant="info">
                                        <h5>Invito rifiutato</h5>
                                        <p>Hai rifiutato l'invito della struttura {clubName}. Non riceverai ulteriori comunicazioni riguardo questo invito.</p>
                                    </Alert>
                                ) : (
                                    <>
                                        {errors.general && (
                                            <Alert variant="danger">
                                                {errors.general}
                                            </Alert>
                                        )}
                                        
                                        <div className="d-grid gap-2">
                                            <Button 
                                                variant="primary" 
                                                onClick={handleAcceptInvite}
                                                disabled={loading}
                                                size="lg"
                                            >
                                                {loading ? (
                                                    <>
                                                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                        Elaborazione...
                                                    </>
                                                ) : (
                                                    'Accetta l\'invito'
                                                )}
                                            </Button>
                                            
                                            <Button 
                                                variant="outline-danger" 
                                                onClick={handleRejectInvite}
                                                disabled={loading}
                                                size="lg"
                                            >
                                                {loading ? (
                                                    <>
                                                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                        Elaborazione...
                                                    </>
                                                ) : (
                                                    'Rifiuta l\'invito'
                                                )}
                                            </Button>
                                        </div>
                                    </>
                                )}
                                
                                <div className="text-center mt-4">
                                    <small className="text-muted">
                                        Hai bisogno di aiuto? Contatta il supporto
                                    </small>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default ManageInvite;